// MUI Imports
import type { Theme } from '@mui/material/styles'

/**
 * The type scale.
 *
 * Two families arrive: `fontFamily` sets everything, and `display` overrides
 * the headings — the brand voice on a title, the reading voice on a table.
 */
const typography = (fontFamily: string, display: string): Theme['typography'] =>
  ({
    fontFamily:
      typeof fontFamily === 'undefined' || fontFamily === ''
        ? [
            '"Plus Jakarta Sans"',
            'sans-serif',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"'
          ].join(',')
        : fontFamily,
    fontSize: 13.125,
    h1: {
      fontFamily: display,
      letterSpacing: '-0.01em',
      fontSize: '2.875rem',
      fontWeight: 700,
      lineHeight: 1.47826
    },
    h2: {
      fontFamily: display,
      letterSpacing: '-0.01em',
      fontSize: '2.375rem',
      fontWeight: 700,
      lineHeight: 1.47368421
    },
    h3: {
      fontFamily: display,
      letterSpacing: '-0.01em',
      fontSize: '1.75rem',
      fontWeight: 700,
      lineHeight: 1.5
    },
    h4: {
      fontFamily: display,
      letterSpacing: '-0.01em',
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.58334
    },
    h5: {
      fontFamily: display,
      letterSpacing: '-0.01em',
      fontSize: '1.125rem',
      fontWeight: 600,
      lineHeight: 1.5556
    },
    h6: {
      fontFamily: display,
      letterSpacing: '-0.01em',
      fontSize: '0.9375rem',
      fontWeight: 600,
      lineHeight: 1.46667
    },
    subtitle1: {
      fontSize: '0.9375rem',
      lineHeight: 1.46667
    },
    subtitle2: {
      fontSize: '0.8125rem',
      fontWeight: 400,
      lineHeight: 1.53846154
    },
    body1: {
      fontSize: '0.9375rem',
      lineHeight: 1.46667
    },
    body2: {
      fontSize: '0.8125rem',
      lineHeight: 1.53846154
    },
    button: {
      fontSize: '0.9375rem',
      lineHeight: 1.46667,
      textTransform: 'none'
    },
    caption: {
      fontSize: '0.8125rem',
      lineHeight: 1.38462,
      letterSpacing: '0.4px'
    },
    overline: {
      fontSize: '0.75rem',
      lineHeight: 1.16667,
      letterSpacing: '0.8px'
    }
  }) as Theme['typography']

export default typography
